import { IconProps } from './types';

export const LogoIcon = (props: IconProps) => (
  <svg viewBox='0 0 143 143' fill='none' {...props}>
    <g clipPath='url(#clip0_2015_28)'>
      <path
        d='M71.4333 134.784L134.746 71.4707L71.433 8.15794L8.12024 71.471L71.4333 134.784Z'
        stroke='white'
        strokeWidth='8'
      />
      <path d='M71.4351 137.446L104.423 104.457L71.435 71.4691L38.4468 104.457L71.4351 137.446Z' fill='#00C4FF' />
      <path
        d='M71.4352 134.782L101.76 104.457L71.4351 74.1327L41.1105 104.457L71.4352 134.782Z'
        stroke='white'
        strokeWidth='8'
      />
    </g>
    <defs>
      <clipPath id='clip0_2015_28'>
        <rect width='143' height='143' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
